export interface NotificationType {
  name: NotificationTypes.ADDITIONAL_CONSUMABLES
    | NotificationTypes.LOW_RATING
    | NotificationTypes.EXPIRED_SCOUT_REPORT
    | NotificationTypes.LOW_NDVI
    | NotificationTypes.ADDITIONAL_SCOUT_REPORT
    | NotificationTypes.DISASTERS
    | NotificationTypes.NEW_USER_REGISTRATION
    | NotificationTypes.NO_USER_FIELD_BIND
    | NotificationTypes.CRITICAL_MALICIOUS;
}

export interface NotificationModel {
  createDate: Date;
  id: number;
  fieldId: string;
  notificationType: NotificationType;
  readed: boolean;
  targetId: string;
  userLogin: string;
}

export enum NotificationTypes {
  ADDITIONAL_CONSUMABLES = 'ADDITIONAL_CONSUMABLES',
  LOW_RATING = 'LOW_RATING',
  EXPIRED_SCOUT_REPORT = 'EXPIRED_SCOUT_REPORT',
  LOW_NDVI = 'LOW_NDVI',
  ADDITIONAL_SCOUT_REPORT = 'ADDITIONAL_SCOUT_REPORT',
  DISASTERS = 'DISASTERS',
  NEW_USER_REGISTRATION = 'NEW_USER_REGISTRATION',
  NO_USER_FIELD_BIND = 'NO_USER_FIELD_BIND',
  CRITICAL_MALICIOUS = 'CRITICAL_MALICIOUS'
}
